module.exports = __webpack_public_path__ + "static/media/download.d0b4f0ba.svg";